import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material';

import { AuthService } from '../../auth';

@Component({
  selector: 'igo-user-dialog',
  template: require('./user-dialog.component.html'),
})
export class UserDialogComponent {

  public user;
  public exp;

  constructor(
    public dialogRef: MatDialogRef<UserDialogComponent>,
    private auth: AuthService
  ) {
    const decodeToken = this.auth.decodeToken();
    this.user = decodeToken.user;
    this.exp = new Date(decodeToken.exp * 1000).toLocaleString();
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/map/user-button/user-dialog.component.ts